import type { KOLProfile } from '../types';

export type FollowerPlatform = 'instagram' | 'tiktok' | 'youtube' | 'facebook' | 'wechat';

/** Prefer first-class DB columns; fall back to legacy `platforms` JSON. */
export function kolPlatformFollowers(k: KOLProfile, platform: FollowerPlatform): number {
  const col =
    platform === 'instagram'
      ? k.instagramFollowers
      : platform === 'tiktok'
        ? k.tiktokFollowers
        : platform === 'youtube'
          ? k.youtubeFollowers
          : platform === 'facebook'
            ? k.facebookFollowers
            : k.wechatFollowers;
  if (col != null && Number.isFinite(col)) return col;
  const p = k.platforms as Record<string, { followers?: number }> | undefined;
  return p?.[platform]?.followers ?? 0;
}

export function kolTotalFollowers(k: KOLProfile): number {
  return (
    kolPlatformFollowers(k, 'instagram') +
    kolPlatformFollowers(k, 'tiktok') +
    kolPlatformFollowers(k, 'youtube') +
    kolPlatformFollowers(k, 'facebook') +
    kolPlatformFollowers(k, 'wechat')
  );
}
